import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from 'tss-react/mui';

const useStyle = makeStyles()(() => ({
  backdrop: {
    position: 'absolute',
    backgroundColor: '#554e4e38',
    zIndex: '1',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  loader: {
    position: 'absolute',
    top: '40%',
    left: '45%',
    zIndex: '2',
  },
}));

interface LoaderWithBackdropProps {
  loaderSize?: number;
}

function LoaderWithBackdrop({ loaderSize }: LoaderWithBackdropProps): JSX.Element {
  const { classes } = useStyle();
  return (
    <>
      <div className={classes.backdrop} />
      <div className={classes.loader}>
        <CircularProgress style={{ color: 'white' }} size={loaderSize} />
      </div>
    </>
  );
}

LoaderWithBackdrop.defaultProps = {
  loaderSize: undefined,
};

export default LoaderWithBackdrop;
